var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"max-width":"100vw"},attrs:{"src":_vm.imgSrc,"srcset":_vm.srcSet}})}
var staticRenderFns = []

export { render, staticRenderFns }